import { useAuth0 } from '@auth0/auth0-react';
import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import styled from 'styled-components';
import etchoLogoWhite from '@/images/etcho-logo-white.svg';
import etchoShapesLogoLight from '@/images/etcho-shapes-logo-light.svg';
import { Breakpoints } from '@/styles/breakpoints';
import Block from '@shared/components/ui/Block';
import { Text } from '@/components/Text';
import { Button } from '@/components/Button';
import { Constrain } from '@/components/Constrain';

export function LoginPage() {
    const { isAuthenticated, isLoading, loginWithRedirect } = useAuth0();
    const navigate = useNavigate();

    // Replaces the old `redirectIfAuthenticated(request)` loader guard.
    useEffect(() => {
        if (!isLoading && isAuthenticated) navigate('/', { replace: true });
    }, [isLoading, isAuthenticated, navigate]);

    return (
        <Wrapper>
            <Constrain width="extra-wide" fillHeight>
                <Inner>
                    <div>
                        <Block style={{ marginBottom: '20vh' }}>
                            <Logo
                                src={etchoLogoWhite}
                                alt="The Etcho logo in white and orange"
                            />
                        </Block>

                        <Block
                            $stack="horizontal"
                            $gap={60}
                            $verticalAlign="center"
                        >
                            <div style={{ flex: 1 }}>
                                <TitleWrapper>
                                    <Text
                                        as="h1"
                                        font="primary"
                                        size="xxLarge"
                                        spacing="medium"
                                        weight="bold"
                                        color="white"
                                    >
                                        Connecting wealth with values
                                    </Text>

                                    <Text
                                        as="p"
                                        size="medium"
                                        spacing="xLarge"
                                        color="white"
                                    >
                                        Grow and differentiate your firm by
                                        modernising your proposition with tools
                                        that connect wealth with values.
                                    </Text>
                                </TitleWrapper>

                                <Button
                                    $variant="secondary"
                                    onClick={() => loginWithRedirect()}
                                >
                                    <Text
                                        as="span"
                                        color="orange"
                                        font="primary"
                                        weight="bold"
                                    >
                                        Log in
                                    </Text>
                                </Button>
                            </div>

                            <div style={{ flex: 1 }}>
                                <img
                                    src={etchoShapesLogoLight}
                                    alt="Etcho shapes logo in light"
                                />
                            </div>
                        </Block>
                    </div>

                    <Text as="div" color="white">
                        Don't have an account?{' '}
                        <Text
                            as="a"
                            color="orange"
                            href="https://www.etcho.io/contact"
                        >
                            Get in touch
                        </Text>
                    </Text>
                </Inner>
            </Constrain>
        </Wrapper>
    );
}

const Wrapper = styled.div`
    background-color: ${({ theme }) => theme.colors.blue};
    height: 100vh;
    background-size: 100%;
    padding: 2vh 20px;

    @media (min-width: ${Breakpoints.Large}) {
        padding: 4vh 20px;
    }
`;

const Inner = styled.div`
    height: 100%;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    gap: 20px;
`;

const TitleWrapper = styled.div`
    max-width: 710px;
`;

const Logo = styled.img`
    width: 146px;
`;
